import { render, staticRenderFns } from "./availableList.vue?vue&type=template&id=9bf54a64"
import script from "./availableList.vue?vue&type=script&lang=js"
export * from "./availableList.vue?vue&type=script&lang=js"
import style0 from "./availableList.vue?vue&type=style&index=0&id=9bf54a64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports